// extracted by mini-css-extract-plugin
module.exports = {"infoSection":"OpportunityParams_infoSection__fWg78","OpportunityParamsItemStyles":"OpportunityParams_OpportunityParamsItemStyles__13Lda","label":"OpportunityParams_label__1FfhT"};